module.exports = __webpack_public_path__ + "img/bottom_qrcode.423db2cf.png";